export default function Testimonials() {
  const testimonials = [
    {
      rating: 5,
      title: 'Travail impeccable et rapide',
      text: 'Intervention très professionnelle pour le remplacement de mes fenêtres. L\'équipe est arrivée à l\'heure, le travail a été fait proprement et rapidement. Je recommande vivement !',
      author: 'Marie Dubois',
      location: 'Lyon 6ème',
      avatar: 'https://public.readdy.ai/ai/img_res/45d88471899f208eb227f0416e109c8d.jpg',
      source: 'google',
    },
    {
      rating: 5,
      title: 'Excellent rapport qualité-prix',
      text: 'Après plusieurs devis, j\'ai choisi FenetrePro et je ne regrette pas. Prix compétitif, matériaux de qualité et finitions parfaites. Mes nouvelles fenêtres sont magnifiques.',
      author: 'Jean-Pierre Martin',
      location: 'Villeurbanne',
      avatar: 'https://readdy.ai/api/search-image?query=distinguished%20french%20senior%20businessman%20in%20his%20late%20fifties%20with%20salt%20and%20pepper%20gray%20hair%20wearing%20modern%20rectangular%20eyeglasses%20dark%20suit%20white%20shirt%20confident%20smile%20clean%20background%20professional%20corporate%20portrait&width=100&height=100&seq=avatar-jeanpierre-gray-glasses-002&orientation=squarish',
      source: 'trustpilot',
    },
    {
      rating: 5,
      title: 'Service client exceptionnel',
      text: 'De la prise de contact au suivi après installation, tout était parfait. L\'équipe est à l\'écoute, de bon conseil et très réactive. Un vrai plaisir de travailler avec des professionnels.',
      author: 'Sophie Leroux',
      location: 'Lyon 3ème',
      avatar: 'https://readdy.ai/api/search-image?query=young%20french%20woman%20in%20her%20early%20thirties%20with%20long%20dark%20brown%20hair%20wearing%20casual%20chic%20teal%20blouse%20bright%20cheerful%20smile%20friendly%20expression%20clean%20minimalist%20background%20natural%20daylight%20portrait%20photography&width=100&height=100&seq=avatar-sophie-brunette-teal-003&orientation=squarish',
      source: 'pagesjaunes',
    },
    {
      rating: 5,
      title: 'Dépannage en urgence efficace',
      text: 'Suite à un bris de glace, ils sont intervenus le jour même. Service d\'urgence très réactif, prix honnête et travail soigné. Merci pour votre professionnalisme !',
      author: 'Thomas Bernard',
      location: 'Caluire-et-Cuire',
      avatar: 'https://readdy.ai/api/search-image?query=handsome%20french%20man%20in%20his%20mid%20thirties%20with%20short%20dark%20black%20hair%20full%20trimmed%20beard%20wearing%20casual%20denim%20shirt%20warm%20genuine%20smile%20outdoor%20natural%20lighting%20modern%20urban%20background%20relaxed%20professional%20portrait&width=100&height=100&seq=avatar-thomas-beard-denim-004&orientation=squarish',
      source: 'google',
    },
    {
      rating: 5,
      title: 'Rénovation complète réussie',
      text: 'Toutes les fenêtres de ma maison ont été changées. Le résultat est au-delà de mes attentes : isolation thermique et phonique parfaite. Je recommande sans hésitation.',
      author: 'Isabelle Petit',
      location: 'Lyon 7ème',
      avatar: 'https://readdy.ai/api/search-image?query=elegant%20french%20woman%20in%20her%20early%20fifties%20with%20shoulder%20length%20auburn%20red%20hair%20wearing%20sophisticated%20burgundy%20blouse%20classic%20pearl%20necklace%20warm%20professional%20smile%20clean%20studio%20background%20executive%20portrait%20refined%20style&width=100&height=100&seq=avatar-isabelle-redhead-burgundy-005&orientation=squarish',
      source: 'trustpilot',
    },
    {
      rating: 5,
      title: 'Artisans compétents et soigneux',
      text: 'Travail de grande qualité sur la restauration de mes fenêtres anciennes. Les artisans sont très compétents et respectueux. Mon appartement a retrouvé tout son cachet.',
      author: 'Michel Rousseau',
      location: 'Vieux Lyon',
      avatar: 'https://readdy.ai/api/search-image?query=distinguished%20elderly%20french%20gentleman%20in%20his%20late%20sixties%20with%20white%20silver%20hair%20wearing%20classic%20tweed%20jacket%20light%20blue%20shirt%20sophisticated%20intellectual%20appearance%20gentle%20wise%20smile%20heritage%20background%20traditional%20portrait&width=100&height=100&seq=avatar-michel-white-tweed-006&orientation=squarish',
      source: 'pagesjaunes',
    },
  ];

  const displayedTestimonials = testimonials.slice(0, 3);

  const getSourceLogo = (source: string) => {
    switch (source) {
      case 'google':
        return (
          <div className="flex items-center space-x-1.5 bg-white px-3 py-1.5 rounded-full shadow-sm border border-gray-100 hover-scale">
            <svg className="w-4 h-4" viewBox="0 0 24 24">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
            </svg>
            <span className="text-xs font-medium text-gray-700">Google</span>
          </div>
        );
      case 'trustpilot':
        return (
          <div className="flex items-center space-x-1.5 bg-white px-3 py-1.5 rounded-full shadow-sm border border-gray-100 hover-scale">
            <svg className="w-4 h-4" viewBox="0 0 24 24">
              <path fill="#00B67A" d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
            </svg>
            <span className="text-xs font-medium text-gray-700">Trustpilot</span>
          </div>
        );
      case 'pagesjaunes':
        return (
          <div className="flex items-center space-x-1.5 bg-white px-3 py-1.5 rounded-full shadow-sm border border-gray-100 hover-scale">
            <svg className="w-4 h-4" viewBox="0 0 24 24">
              <path fill="#FFD500" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z"/>
            </svg>
            <span className="text-xs font-medium text-gray-700">PagesJaunes</span>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <section className="bg-amber-50 py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16 animate-fade-in-up">
          <span className="text-teal-600 font-semibold text-xs uppercase tracking-wider">
            TÉMOIGNAGES
          </span>
          <h2 className="text-4xl lg:text-5xl font-extrabold text-gray-900 mt-3 mb-4">
            Ce Que Disent Nos Clients
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            La satisfaction de nos clients est notre meilleure récompense
          </p>

          {/* Review Platforms Stats */}
          <div className="flex flex-wrap justify-center items-center gap-8 mt-10">
            {/* Google Reviews */}
            <div className="flex items-center space-x-3 animate-fade-in-up delay-100 hover-lift cursor-pointer">
              <svg className="w-8 h-8" viewBox="0 0 24 24">
                <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
              </svg>
              <div className="text-left">
                <div className="flex items-center space-x-1">
                  <span className="font-bold text-gray-900 text-lg">4.9</span>
                  <div className="flex text-orange-500">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-sm"></i>
                    ))}
                  </div>
                </div>
                <div className="text-xs text-gray-600">245 avis Google</div>
              </div>
            </div>

            {/* Trustpilot */}
            <div className="flex items-center space-x-3 animate-fade-in-up delay-200 hover-lift cursor-pointer">
              <svg className="w-8 h-8" viewBox="0 0 24 24">
                <path fill="#00B67A" d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
              </svg>
              <div className="text-left">
                <div className="flex items-center space-x-1">
                  <span className="font-bold text-gray-900 text-lg">4.8</span>
                  <div className="flex text-orange-500">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-sm"></i>
                    ))}
                  </div>
                </div>
                <div className="text-xs text-gray-600">189 avis Trustpilot</div>
              </div>
            </div>

            {/* Pages Jaunes */}
            <div className="flex items-center space-x-3 animate-fade-in-up delay-300 hover-lift cursor-pointer">
              <svg className="w-8 h-8" viewBox="0 0 24 24">
                <path fill="#FFD500" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z"/>
              </svg>
              <div className="text-left">
                <div className="flex items-center space-x-1">
                  <span className="font-bold text-gray-900 text-lg">4.7</span>
                  <div className="flex text-orange-500">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-sm"></i>
                    ))}
                  </div>
                </div>
                <div className="text-xs text-gray-600">156 avis PagesJaunes</div>
              </div>
            </div>
          </div>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7">
          {displayedTestimonials.map((testimonial, index) => (
            <div
              key={index}
              className={`bg-white rounded-2xl p-8 shadow-md hover:shadow-xl transition-all duration-300 card-hover animate-fade-in-up delay-${(index + 4) * 100}`}
              style={{ opacity: index >= 3 ? 0.85 : 1 }}
            >
              {/* Source Logo */}
              <div className="mb-4">
                {getSourceLogo(testimonial.source)}
              </div>

              {/* Stars */}
              <div className="flex space-x-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-orange-500 text-lg"></i>
                ))}
              </div>

              {/* Title */}
              <h3 className="text-lg font-semibold text-gray-900 mb-3">
                {testimonial.title}
              </h3>

              {/* Text */}
              <p className="text-gray-600 text-sm leading-relaxed mb-6">
                {testimonial.text}
              </p>

              {/* Author */}
              <div className="flex items-center space-x-3">
                <img
                  src={testimonial.avatar}
                  alt={testimonial.author}
                  className="w-12 h-12 rounded-full object-cover hover-scale transition-transform duration-300"
                  loading="lazy"
                  decoding="async"
                  fetchpriority="low"
                />
                <div>
                  <div className="font-semibold text-gray-900 text-sm">
                    {testimonial.author}
                  </div>
                  <div className="text-gray-500 text-xs">
                    {testimonial.location}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
